import React from 'react';
import { useTranslation } from 'react-i18next';
import './ComingSoonOverlay.css';

const ComingSoonOverlay = ({ message, title, onClose, className = '' }) => {
  const { t } = useTranslation('common');
  
  // Use provided translations or fallback to defaults
  const displayTitle = title || t('common.comingSoon.title', { defaultValue: 'Coming Soon' });
  const displayMessage = message || t('common.comingSoon.message', { defaultValue: 'This feature is being prepared for you.' });
  
  return (
    <div className={`coming-soon-overlay ${className}`}>
      {/* Dark overlay layer */}
      <div className="coming-soon-backdrop"></div>
      
      {/* Blurred background layer */}
      <div className="coming-soon-blur"></div>
      
      {/* Close button - Top right corner */}
      {onClose && (
        <button className="coming-soon-close-btn" onClick={onClose}>
          <i className="material-icons">close</i>
        </button>
      )}
      
      {/* Centered message card */}
      <div className="coming-soon-card">
        {/* Lock icon */}
        <div className="coming-soon-icon">
          <i className="material-icons">lock_outline</i>
        </div>
        
        {/* "Coming Soon" text */}
        <h2 className="coming-soon-title">{displayTitle}</h2>
        
        {/* Message */}
        <p className="coming-soon-message">{displayMessage}</p>
      </div>
    </div>
  );
};

export default ComingSoonOverlay;

